// Dependencies
require("webstrap/type");
require("webstrap/forms");
require("webstrap/buttons");
require("grid");
require("section/generic");

// JavaScript
var $ = jQuery = require('jquery');

if ($('.js-form-quote').length > 0) {
    require("forms-validation");
    $('.js-form-quote').validate(require("forms-validation/options/defaults.js"));
}


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/quote/index.js
 ** module id = 73
 ** module chunks = 0 1
 **/